<template>
  <McGrapqlTable
    :fields="fields"
    :searchable="true"
    :customHandlers="customHandlers"
    :withCard="false"
    :apiClient="query"
    trackBy="partId"
    :isSelectableField="false"
    :customToast="customToast"
    :isEmpty="noData"
    :isLoading="isLoading"
  >
    <template #viewManager="{ handleSetDataFields, dataFields, initialFields }">
      <McFilterSelect
        :defaultColumnOrder="initialFields"
        :currentColumnOrder="dataFields"
        @setColumn="handleSetDataFields"
      />
    </template>
    <template #cell(partType)="data">
      {{ data.value.type }}
    </template>
    <template #cell(partBrand)="data">
      {{ data.value.brand }}
    </template>
    <template #cell(quality)="data">
      {{
        data.value === 'Original'
          ? 'Pabrikan'
          : data.value === 'Aftermarket'
          ? 'Non Pabrikan'
          : data.value === 'Replica'
          ? 'Replika'
          : ''
      }}
    </template>
    <template #cell(partCategory)="data">
      {{ data.item.partType?.partCategory?.category }}
    </template>
    <template #cell(unit)="data">
      {{ data.value.charAt(0).toUpperCase() + data.value.slice(1) }}
    </template>
    <template #cell(price)="data"> {{ `Rp ${thousandFormat(data.value)}` }} </template>
    <template #emptyState>
      <McEmptyState
        :title="$t('master.parts.emptyState.title')"
        :desc="$t('master.parts.emptyState.desc')"
        @buttonPrimaryAction="customHandlers.handleAdd"
        class="pb-4"
      ></McEmptyState>
    </template>
  </McGrapqlTable>
</template>

<script>
import McGrapqlTable from '@/components/McGrapqlTable'
import McFilterSelect from '@/components/McFilterSelect'
import { GET_PARTS, DELETE_PART } from '@/services/api/master/spareparts'
import { Helper } from '@/mixin/helper'
import McEmptyState from '@/components/McEmptyState'

export default {
  components: {
    McGrapqlTable,
    McFilterSelect,
    McEmptyState,
  },

  mixins: [Helper],

  data() {
    return {
      customHandlers: {
        handleClickRow: (data) => {
          this.$router.push({
            name: 'Service Spare Part Update',
            params: { id: data.partId },
          })
        },
        handleAdd: () => {
          this.$router.push({
            name: 'Service Spare Part Add',
          })
        },
      },
      noData: true,
      isLoading: true,
    }
  },

  computed: {
    fields() {
      return [
        {
          key: 'code',
          thClass: 'mc-table--50',
          label: this.$t('master.parts.sparePartCode'),
          sortable: true,
          isRedirectable: true,
          isLocked: true,
        },
        {
          key: 'name',
          thClass: 'mc-table--50',
          label: this.$t('master.parts.sparePartName'),
          sortable: true,
        },
        {
          key: 'partCategory',
          thClass: 'mc-table--50',
          label: this.$t('master.parts.category'),
          sortable: true,
        },
        {
          key: 'partType',
          thClass: 'mc-table--50',
          label: this.$t('master.parts.sparePartType'),
          sortable: true,
        },
        {
          key: 'partBrand',
          thClass: 'mc-table--50',
          label: this.$t('master.parts.brand'),
          sortable: true,
        },
        {
          key: 'sku',
          thClass: 'mc-table--50',
          label: this.$t('master.parts.sku'),
          sortable: true,
        },
        {
          key: 'quality',
          thClass: 'mc-table--50',
          label: this.$t('master.parts.quality'),
          sortable: true,
        },
        {
          key: 'description',
          thClass: 'mc-table--50',
          label: this.$t('master.parts.description'),
          sortable: true,
        },
        {
          key: 'unit',
          thClass: 'mc-table--50',
          label: this.$t('master.parts.unit'),
          sortable: true,
        },
        {
          key: 'price',
          thClass: 'mc-table--50',
          label: this.$t('master.parts.buyingPrice'),
          sortable: true,
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          this.isLoading = true

          const res = await this.$apollo.query({
            query: GET_PARTS,
            fetchPolicy: 'no-cache',
            variables: {
              filter: filter,
            },
          })

          if (res.data.parts.parts.pagination.total === 0) this.noData = true
          else this.noData = false
          this.isLoading = false

          return res.data.parts.parts
        },
        delete: async (id) => {
          const res = await this.$apollo.query({
            query: DELETE_PART,
            fetchPolicy: 'no-cache',
            variables: {
              input: {
                partId: +id,
              },
            },
          })

          return res.data.deletePart.isSuccessful
        },
      }
    },
  },

  methods: {
    customToast() {
      this.$mcToast.error({
        component: 'McToastDynamicBody',
        props: {
          contents: [
            {
              tag: 'h6',
              text: this.$t('maintenance.alert.deleteFailed'),
            },
            {
              tag: 'p',
              text: this.$t('maintenance.alert.failedDeteleUsed'),
            },
          ],
        },
      })
    },
  },
}
</script>
